import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { ArquivoResponse } from '../models/arquivoResponse.model';
import { ViewModelConsultaDocs } from '../models/viewModelConsultaDocs.model';
import { WebConsultaDocsFiltro } from '../models/webConsultaDocsFiltro.model';

@Injectable({
    providedIn: 'root'
})
export class UploadDocumentsService {

    private readonly baseUrl =
        `${environment.TrustCRMApiHost}api/UploadDocuments`;

    constructor(private http: HttpClient) { }

    visualizarDocumento(cpf: string): Observable<ArquivoResponse[]> {
        const url = `${this.baseUrl}/visualizarDocumentos/${cpf}`;
        return this.http.get<ArquivoResponse[]>(url);
    }
    getAllConsultaDocs(): Observable<ViewModelConsultaDocs[]> {
        const url = `${this.baseUrl}/getAllConsultaDocs`;
        return this.http.get<ViewModelConsultaDocs[]>(url);
    }

    filtrar(webConsultaDocsFiltro: WebConsultaDocsFiltro) {
        return this.http.post<ViewModelConsultaDocs[]>(this.baseUrl + `/Filtrar`, webConsultaDocsFiltro);
    }
}
